import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import LinearProgress from '@mui/material/LinearProgress';
import { makeStyles } from '@mui/styles';
import { IconGraphy, colors, Typography, Alert } from '@leapeasy/ui-kit';

import leap from 'assets/leap.jpeg';

const useStyles = makeStyles({
  success_logo: {
    borderRadius: '50px !important',
    width: '250px',
    height: '250px',
    backgroundColor: '#f0c2c254',
    padding: 5,
    marginRight: '23px',
  },
});

const Success = () => {
  const classes = useStyles();
  const formData = useSelector((state) => state.formData);

  return (
    <Box className="py-5">
      {!formData.success && !formData.error && (
        <Box>
          <Box sx={{ width: 'fit-content', margin: 'auto' }}>
            <img src={leap} className={classes.success_logo} />
            <LinearProgress className={classes.linear_progress} />
          </Box>

          <Box display="flex" flexDirection="column" gap="12px" sx={{ marginTop: 4 }}>
            <Typography
              variant="body1"
              style={{ fontWeight: '500', color: colors.purple[900], textAlign: 'center' }}
            >
              We're sending your application now, please don't close this window
            </Typography>
          </Box>
        </Box>
      )}

      {formData.success && (
        <>
          <Box
            sx={{
              width: 128,
              height: 128,
              borderRadius: '50%',
              background: colors.purple[100],
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <IconGraphy
              icon="Notifications.MarkMailRead"
              width={63}
              height={54}
              style={{ color: colors.purple[700] }}
            />
          </Box>

          <Box display="flex" flexDirection="column" gap="12px" sx={{ marginTop: 4 }}>
            <Typography variant="h3" style={{ fontWeight: '500', color: colors.purple[900] }}>
              Your application has been successfully sent to Leap!
            </Typography>

            <Typography variant="body1" style={{ color: colors.neutral[900] }}>
              We will be reaching out to you shortly
            </Typography>
          </Box>
        </>
      )}

      {formData.error && (
        <Alert
          showIcon
          showClose={false}
          showBorder={false}
          type="error"
          variant="contained"
          title="Error"
          description={
            typeof formData.error === 'string' ? formData.error : formData.error?.message || 'Something went wrong. Please try again.'
          }
        />
      )}
    </Box>
  );
};

export default Success;
